var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Head 2 Head")]),_c('H2H',{attrs:{"selectedMatch":_vm.selectedMatch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }